import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { Calendar, Clock, CheckCircle, XCircle } from "lucide-react";

const ViewReminderReport = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [reminders, setReminders] = useState([]);


  const location = useLocation();

  const fetchReminders = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_create_report_excel",
        JSON.stringify({patient_id : patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setReminders(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch reminders. Try again later.");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchReminders()
  }, []);

  const formatResponseStatus = (status) => {
    console.log(status)
    if (status === "true" || status ===true) return { text: "Taken", className: "bg-green-100 text-green-700" };
    if (status === "false" || status ===false) return { text: "Missed", className: "bg-red-100 text-red-700" };
    return { text: "Pending", className: "bg-yellow-100 text-yellow-800" };
  };


  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="p-6 max-w-6xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
          ⏰ Reminder Report
        </h2>

        {reminders.length === 0 ? (
          <div className="text-center text-gray-500 italic py-10">
            No reminders available.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {reminders.map((reminder, index) => {
                console.log(reminder)
              const { text, className } = formatResponseStatus(reminder.pill_reponse);
              return (
                <div
                  key={index}
                  className="bg-white shadow-md rounded-2xl p-5 border border-blue-100 hover:shadow-xl transition duration-300"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <Calendar className="text-blue-600 w-5 h-5" />
                    <h3 className="text-lg font-semibold text-blue-800">
                      {new Date(reminder.date).toLocaleDateString()}
                    </h3>
                  </div>

                  <div className="flex items-center text-sm text-gray-600 mb-2">
                    <Clock className="w-4 h-4 mr-2" />
                    <span>{(reminder.time)}</span>
                  </div>

                  <div className="flex items-center text-sm text-gray-600 mb-2">
                    <span>{reminder.weekday}</span>
                  </div>

                  <div className="mt-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${className}`}
                    >
                      {text}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReminderReport;
